module.exports = __webpack_public_path__ + "static/media/previousIcon.07265b13.svg";